import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TrlPillContainer, TrlPillLabel } from '../TrlPill.styles';
import { TrlPillCanceledStyled } from '../TrlPillCanceled/TrlPillCanceled.styles';
import {
  TrlPillAnulPendingStyled,
  TrlPillDotStyled,
} from './TrlPillAnulPending.styles';

export const TrlPillAnulPending = () => {
  return (
    <TrlPillContainer>
      <TrlPillCanceledStyled />
      <TrlPillAnulPendingStyled
        label={
          <>
            <TrlPillDotStyled />
            <TrlPillDotStyled />
            <TrlPillDotStyled />
          </>
        }
      />
      <TrlPillLabel>
        <FormattedMessage id="TRLT_UI-PENDING_CANCELLATION" />
      </TrlPillLabel>
    </TrlPillContainer>
  );
};
